import React, { useCallback, useEffect, useState } from 'react';
import Tabs from './Tabs';

const SRGLetterboxPlayerEvents = ({ letterboxInstance }) => {
  const [letterboxEvents, setLetterboxEvents] = useState({});
  const [listenedEvents, setListenedEvents] = useState([]);

  const listenToEvent = useCallback(
    event => {
      if (!letterboxInstance) {
        return null;
      }

      const events = [...listenedEvents];

      const index = events.indexOf(event);

      if (index < 0) {
        events.push(event);
        console.log('Start listening to ' + event);
        letterboxInstance.on(event, console.log);
      } else {
        events.splice(index, 1);
        console.log('Stop listening to ' + event);
        letterboxInstance.off(event, console.log);
      }

      setListenedEvents(events);
    },
    [listenedEvents, letterboxInstance]
  );

  useEffect(() => {
    if (window.SRGLetterbox) {
      setListenedEvents([]);
      setLetterboxEvents({
        VIDEOJS: Object.entries(window.SRGLetterbox.videojsEvents),
        SRG: Object.entries(window.SRGLetterbox.srgEvents),
        PLAYER: Object.entries(window.SRGLetterbox.playerEvents),
        ALL: Object.entries(window.SRGLetterbox.events)
      });
    }
  }, [letterboxInstance]);

  return (
    <>
      <h1 className="content__title">Player Events</h1>
      <Tabs>
        {Object.keys(letterboxEvents).map(evtCategory => {
          const categoryEvents = letterboxEvents[evtCategory];
          return (
            <div key={evtCategory} label={evtCategory}>
              <div className="tabs__panel">
                {categoryEvents.map(([event, value]) => {
                  const activeClass = listenedEvents.includes(value) ? 'tabs__panel__item--active' : '';
                  return (
                    <div className={`tabs__panel__item ${activeClass}`} key={value} onClick={() => listenToEvent(value)}>
                      {event}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </Tabs>
    </>
  );
};

export default SRGLetterboxPlayerEvents;
